module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAPCAYAAAAVk7TYAAAAAXNSR0IArs4c6QAAANNJREFUOE+t1L0NwjAQBWC/FEkJo2QDWIENjiI/JSPABpRJKpiAEWAE1kmTh4xkJMBJfAa3vtOnJ90djOKJyDLLsosxZg1g2zTNSdFuEFpsoTRNrwBy16MFgzAfFAPOYlOQFpzEfBDJM8kjgBuAhQYcxcagruvEAkVR5FrQi81BLo0W/MJCoRjwDdNCWvCFxUIa8In9CoWC+BcUAqIsS7svK1ds98iNd+gp+6zzTSnJDaqq4j+hsYQkD6jrWoZhEAD3tm13sWl8fTZhkiR7+9f3vTwAzbGkdObAy/AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/gotop.png
// module id = wMmT
// module chunks = 1